// 语言状态管理
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface LanguageState {
  currentLanguage: string;
  availableLanguages: string[];
}

const initialState: LanguageState = {
  currentLanguage: 'zh-TW',
  availableLanguages: ['zh-TW', 'en', 'pt'],
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export const selectLanguage = (state: RootState) => state.language.currentLanguage;
export const selectAvailableLanguages = (state: RootState) => state.language.availableLanguages;

export default languageSlice.reducer;
